import React, { useEffect, useState } from 'react'
import { database } from '../Services/firebaseconfig';
import { doc, onSnapshot } from 'firebase/firestore';

import love_like from '../Assets/Home page 1/love like.svg'
import reply_icon from '../Assets/Home page 1/reply icon.svg'


const EachComment = (props) => {

    const [commentData, setCommentData] = useState([])

    // console.log(commentData);

    useEffect(() => {
        // console.log(follower);
        const q = doc(database, "User Data", props.comment.uid);
        onSnapshot(q, (data) => {
            //   console.log(data.data());
            if (data.exists) {
                setCommentData((commentData) => [
                    ...commentData,
                    { ...data.data(), uid: data.id },
                ]);
            }
            else {
                // console.log("invalid uid");
            }
        });
    }, [props.twigId])



    return (
        <>
            <div className="comment_text">
                <div>
                    <div>
                        <div>
                            <img src={commentData[0]?.img} />
                            <p>{commentData[0]?.name}</p>
                            <p>1 min ago</p>
                        </div>
                        <p>{props.comment.text}</p>
                        <div>
                            <img src={love_like} />
                            <p>1.2k</p>
                            {/* <hr />
                            <img src={reply_icon} />
                            <p>Reply</p> */}
                        </div>
                    </div>
                </div>

                {/* <div className="reply_comment">
                                <em></em>
                                <div className="reply-comment-text">
                                    <div>
                                        <div>
                                            <div>
                                                <img src={comment_profile} />
                                                <p>Clara Albert</p>
                                                <p>1 min ago</p>
                                            </div>
                                            <p>Babu ne thana thaya 🙉🙉🙉</p>
                                            <div>
                                                <img src={love_like} />
                                                <p>1.2k</p>
                                                <hr />
                                                <img src={reply_icon} />
                                                <p>Reply</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
            </div>
        </>
    )
}

export default EachComment
